import React from "react";
import "./style.scss";

const Loader = () => {
  return (
    <div className="loader">
        <div className="dot-loader"></div>
        <div className="dot-loader dot-loader--2"></div>
        <div className="dot-loader dot-loader--3"></div>
    </div>
  );
};
export default Loader;
